import  React, { useState, useRef, useEffect, useContext  } from "react";
import * as RecordRTC from 'recordrtc';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Icons } from "../assest/icons";
import Header from './header';
import moment from 'moment';
import { ToastContainer, toast } from "react-toastify";
import axios from 'axios';
import LoaderSpinner from './loaderSpinner';
import { SearchContext } from './admin/SearchContext';
import { logger } from '../utils/logger';
import Modal from 'react-modal';
import HeightFormatter, { formatHeight } from './HeightFormatter';
import {
  getUserSessions,
  getInsuranceData,
  getIllnesses,
  getMedicalReports,
  getPCPPharmacyDetails,
  getAllFollowupRequests,
  getActiveFollowupRequest,
  createAdminLog,
  updateChatSession
} from '../services/firestore';
import { addDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase.config';
import html2pdf from "html-to-pdf-js";
import { PDFDocument } from "pdf-lib";
import { fetchWithAppCheck } from '../utils/fetchWithAppCheck';
import { downloadMyFHIRBundle, getFHIRResource } from '../services/fhirService';

// Assessment & Plan PDF imports
import AbdominalCT from '../assest/document/AIGICare_PDF_AbdominalCT.pdf';
import AbdominalUS from '../assest/document/AIGICare_PDF_AbdominalUS.pdf';
import AnemiaLabs from '../assest/document/AIGICare_PDF_AnemiaLabs.pdf';
import BariumStudies from '../assest/document/AIGICare_PDF_BariumStudies.pdf';
import BasicGastroLabs from '../assest/document/AIGICare_PDF_BasicGastroLabs.pdf';
import ColonOrder from '../assest/document/AIGICare_PDF_Colon_Order.pdf';
import Colonoscopy from '../assest/document/AIGICare_PDF_Colonoscopy.pdf';
import ColonScreeningGuidelines from '../assest/document/AIGICare_PDF_ColonScreeningGuidelines.pdf';
import Diverticulosis from '../assest/document/AIGICare_PDF_Diverticulosis.pdf';
import EGDOrder from '../assest/document/AIGICare_PDF_EGD_Order.pdf';
import FattyLiver from '../assest/document/AIGICare_PDF_FattyLiver.pdf';
import GERD_Diet_and_Lifestyle from '../assest/document/AIGICare_PDF_GERD_Diet_and_Lifestyle.pdf';
import HeapticLabs from '../assest/document/AIGICare_PDF_HeapticLabs.pdf';
import High_Fiber_Diet from '../assest/document/AIGICare_PDF_High_Fiber_Diet.pdf';
import InflammatoryBowelDisease from '../assest/document/AIGICare_PDF_InflammatoryBowelDisease.pdf';
import IrritableBowelSyndrome from '../assest/document/AIGICare_PDF_IrritableBowelSyndrome.pdf';
import ProceduralSedation from '../assest/document/AIGICare_PDF_ProceduralSedation.pdf';
import StoolStudies from '../assest/document/AIGICare_PDF_StoolStudies.pdf';
import StressManagement from '../assest/document/AIGICare_PDF_StressManagement.pdf';
import TelehealthDisclaimer from '../assest/document/AIGICare_PDF_TelehealthDisclaimer.pdf';
import UpperGIEndoscopy from '../assest/document/AIGICare_PDF_UpperGIEndoscopy.pdf';
import Weight_Reducing_Diet from '../assest/document/AIGICare_PDF_Weight_Reducing_Diet.pdf';

import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';

// Set the app element for accessibility (react-modal requirement)
Modal.setAppElement('#root');

const renderAISummary = (text) => {
  if (!text) return null;
  const lines = text.split('\n');
  const elements = [];
  const renderBold = (line) => {
    const parts = line.split(/\*\*(.*?)\*\*/g);
    return parts.map((part, idx) => idx % 2 === 1 ? <strong key={idx}>{part}</strong> : part);
  };
  lines.forEach((line, i) => {
    const trimmed = line.trim();
    if (!trimmed) return;
    if (/^THERAPIES\s*:/i.test(trimmed)) return;
    if (/^\d+\.\s+/.test(trimmed) || /^[A-Z][A-Z\s,/&]+:/.test(trimmed)) {
      const cleanedTrimmed = trimmed.replace(/^\d+[\.\)]\s*/, '');
      const colonIdx = cleanedTrimmed.indexOf(':');
      const headingPart = colonIdx !== -1 ? cleanedTrimmed.slice(0, colonIdx + 1) : cleanedTrimmed;
      const descPart = colonIdx !== -1 ? cleanedTrimmed.slice(colonIdx + 1).trim() : '';
      elements.push(
        <div key={`h-${i}`} style={{marginTop:'14px', marginBottom:'5px', borderBottom:'1px solid #e3eaf5', paddingBottom:'3px'}}>
          <span style={{fontWeight:'700', color:'#024C9C', fontSize:'14px'}}>{renderBold(headingPart)}</span>
          {descPart && <span style={{fontWeight:'400', color:'#222', fontSize:'14px'}}> {renderBold(descPart)}</span>}
        </div>
      );
    } else if (/^[•\-]\s+/.test(trimmed)) {
      const cleanLine = trimmed.replace(/^[•\-]\s+/, '');
      if (cleanLine) elements.push(
        <div key={`b-${i}`} style={{display:'flex', alignItems:'flex-start', margin:'4px 0 4px 8px', lineHeight:'1.6'}}>
          <span style={{marginRight:'8px', color:'#024C9C', fontWeight:'700'}}>•</span>
          <span>{renderBold(cleanLine)}</span>
        </div>
      );
    } else {
      const cleanLine = trimmed.replace(/^\*+\s*/, '');
      if (cleanLine) elements.push(<p key={`p-${i}`} style={{margin:'3px 0 3px 4px', lineHeight:'1.5'}}>{renderBold(cleanLine)}</p>);
    }
  });
  return <div style={{fontSize:'13.5px'}}>{elements}</div>;
};
 
function PatientDashboard() { 
  const userProfileData =  JSON.parse(localStorage.getItem('UserProfile')) || {};
  const [myinsuranceinfo, setMyinsuranceinfo] = useState([]);  
  const [CheckExpiry, setCheckExpiry] = useState(false);  
const [UserId, setUserId] = useState(userProfileData?.id || userProfileData?.user_id || JSON.parse(localStorage.getItem('UserId')) || '');
  const [GenderTxt, setGenderTxt] = useState(userProfileData?.gender || '');
  var years = moment().diff(userProfileData?.dob || '');
  const [AgeTxt, setAgeTxt] = useState(years);
  const [fullName, setFullName] = useState(userProfileData?.fullName || '');
  const [email, setEmail] = useState(userProfileData?.email || '');
  const [phoneNumber, setPhoneNumber] = useState(userProfileData?.phoneNumber || '');
  const [DOBTxt, setDOBTxt] = useState(userProfileData?.dob || '');
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingCD, setIsEditingCD] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isDownloadingFHIR, setIsDownloadingFHIR] = useState(false);
  const [fhirSummary, setFhirSummary] = useState(null);
  const [fhirSummaryLoading, setFhirSummaryLoading] = useState(false);
  const [showFhirSummary, setShowFhirSummary] = useState(false);
  var years = moment().diff(DOBTxt || '');
  const ageCal = DOBTxt ? moment().diff(DOBTxt, 'years') : 0;    

  // const [userProfileData, setUserProfileData] = useState(JSON.parse(localStorage.getItem('UserProfile')));

// --------------------------------------------------

const location = useLocation();  
 

let navigate = useNavigate();
const routeChange = () => { 
  navigate('/admin/dashboard', {
     state: {backCurrentPage: backCurrentPage, searchTxt: searchTxtCheck }  
  }); 
} 
let navigateNew = useNavigate();
const goToPatientHistory = (sessionid) => {
  navigateNew(`/patienthistory/${sessionid}-${currentPage}`); // Include the user ID in the path
};

const newappointmentLink = () => {
  if(CheckExpiry){
    // navigate('/myinsurance');
    navigate('/newappointment');

  }else{
    navigate('/newappointment');
  }

}

const handleDownloadMyFHIR = async () => {
  if (isDownloadingFHIR) return;
  setIsDownloadingFHIR(true);
  try {
    const bundle = await downloadMyFHIRBundle(UserId);
    if (!bundle) {
      toast.error('Failed to download health data. Please try again.', { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    const blob = new Blob([JSON.stringify(bundle, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'my-health-data-fhir.json';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    toast.success('Health data downloaded!', { position: toast.POSITION.TOP_RIGHT });
  } catch (err) {
    logger.error('FHIR self-download error', err);
    toast.error('An error occurred. Please try again.', { position: toast.POSITION.TOP_RIGHT });
  } finally {
    setIsDownloadingFHIR(false);
  }
};

// Extract a short readable label from a long FHIR text field
const extractShortText = (text) => {
  if (!text) return null;
  const firstLine = text.split('\n')[0].split('.')[0].trim();
  return firstLine.length > 80 ? firstLine.substring(0, 80) + '...' : firstLine;
};

const loadFHIRSummary = async (userId) => {
  if (!userId || fhirSummaryLoading) return;
  setFhirSummaryLoading(true);
  try {
    // Step 1: Read illness name directly from chatbot sessions (clean names like "Acid Reflux")
    const sessionsSnap = await getDocs(query(collection(db, 'chatbot'), where('user_id', '==', userId)));
    const seen = new Set();
    const uniqueConditions = sessionsSnap.docs
      .map(d => d.data().illness)
      .filter(illness => illness && !seen.has(illness) && seen.add(illness))
      .map(illness => ({ _label: illness }));

    // Step 2: Get all medical_report IDs for this patient
    const reportsSnap = await getDocs(query(collection(db, 'medical_reports'), where('user_id', '==', userId)));
    const reportIds = reportsSnap.docs.map(d => d.data().doc_id || d.id);

    // Step 3: Fetch Allergies & Medications from FHIR resources
    const allergyPromises = reportIds.map(rid => getFHIRResource('AllergyIntolerance', `allergy-${rid}`));
    const medicationPromises = reportIds.map(rid => getFHIRResource('MedicationStatement', `med-${rid}`));

    const [allergyResults, medicationResults] = await Promise.all([
      Promise.all(allergyPromises),
      Promise.all(medicationPromises),
    ]);

    setFhirSummary({
      conditions: uniqueConditions,
      allergies: allergyResults.filter(r => r !== null),
      medications: medicationResults.filter(r => r !== null),
    });
  } catch (err) {
    logger.error('FHIR summary load error', err);
    setFhirSummary({ conditions: [], allergies: [], medications: [] });
  } finally {
    setFhirSummaryLoading(false);
  }
};

// Detect if this is a full page reload
const isPageReload =
  performance.getEntriesByType("navigation")[0]?.type === "reload";

// Determine initial page count
const initialPage = isPageReload
  ? 1 // On reload, reset to page 1
  : location.state?.currentPage || 1; // Use the state if available

const [currentPage, setCurrentPage] = useState(initialPage);

useEffect(() => {
  // On reload, reset location.state to ensure future navigation starts fresh
  if (isPageReload) {
    navigate(location.pathname, { replace: true, state: { currentPage: 1 } });
  }
}, [isPageReload, location.pathname, navigate]);


// useEffect(() => { 
//     setCurrentPage(currentPageFromState); // Set currentPage when the component mounts
//   }, [currentPageFromState]);

// const location = useLocation(); 
// const { id, currentPageNo, searchString } = location.state;

 


const [ShowLoaderPage, setShowLoaderPage] = useState(false);
const [userid, setuserid] = useState(UserId); 
const [adminId, setAdminId] = useState(JSON.parse(localStorage.getItem('UserIdAdmin'))); 

const [searchTxtCheck, setSearchTxtCheck] = useState(''); 
// const [searchTxtCheck, setSearchTxtCheck] = useState(searchString); 

const [backCurrentPage, setcurrentPageNo] = useState(''); 
// const [backCurrentPage, setcurrentPageNo] = useState(currentPageNo); 
const [UserHistoryData, setUserHistoryData] = useState([]);
const [UserHistoryNumber, setUserHistoryNumber] = useState('');
const [ChatHistory, setChatHistory] = useState([]);
const [RecordData, setRecordData] = useState([]);  
const [BackReload, setBackReload] = useState(false);     
const [userProfile, setUserProfile] = useState('');  
const [specialty, setSpecialty] = useState('');
const [selectedToggle, setSelectedToggle] = useState(true); 
const [InsuranceIdTxt, setInsuranceIdTxt] = useState(''); 
const [originalProfile, setOriginalProfile] = useState({});   
var years = moment().diff(DOBTxt); 
const [BMITxt, setBMITxt] = useState('');   
 
const [WeightTxt, setWeightTxt] = useState('');
const [HeightTxt, setHeightTxt] = useState('');
const [ShowLoader, setShowLoader] = useState(false); 
 
const [showCalendar, setShowCalendar] = useState(false);  
const [isValid, setIsValid] = useState(false);
const [isSession, setIsSession] = useState(false);

// const [currentPage, setCurrentPage] = useState(currentPageFromState); 
const [currentPageGroup, setCurrentPageGroup] = useState(1); 

 
const [recordsPerPage, setRecordsPerPage] = useState(10);
const [showSummay, setShowSummary] = useState(false);
const [totalRecords, setTotalRecords] = useState(1);
//const totalPages = Math.ceil(UserHistoryData.length / recordsPerPage);
// const totalPageGroups = Math.ceil(totalPages / 3);
// const currentPageGroup = Math.ceil(currentPage / 3);
 
const totalPages = Math.ceil(totalRecords / recordsPerPage);
 

const [illnessesList, setIllnessesList] = useState([]);
const [selectedIllness, setSelectedIllness] = useState(null);
const [answerLoader, setAnswerLoader] = useState(false);
const [EmergencyQuest, setEmergencyQuest] = useState(false);

const [activeTab, setActiveTab] = useState(0);
const { searchQuery } = useContext(SearchContext);

const [MainPointsDiscussed, setMainPointsDiscussed] = useState('');
const [PlanOnCareData, setPlanOnCareData] = useState('');
const [ConditionalDiagnosis, setConditionalDiagnosis] = useState('');
const [finalConsultantNote, setFinalConsultantNote] = useState('');
const [finalConsultantDiagnosis, setFinalConsultantDiagnosis] = useState('');
const [finalConsultantPlan, setFinalConsultantPlan] = useState('');
const [finalConsultantHPI, setFinalConsultantHPI] = useState('');
const [finalConsultantPMH, setFinalConsultantPMH] = useState('');
const [finalConsultantMedications, setFinalConsultantMedications] = useState('');
const [finalConsultantAllergies, setFinalConsultantAllergies] = useState('');
const [finalConsultantSocialHistory, setFinalConsultantSocialHistory] = useState('');
const [finalConsultantROS, setFinalConsultantROS] = useState('');
const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
const [selectedFinalNoteFiles, setSelectedFinalNoteFiles] = useState([]);
const [doctorRecommendations, setDoctorRecommendations] = useState([]);
const [isFinalNoteSubmitted, setIsFinalNoteSubmitted] = useState(false);
const [patientReportHistory, setPatientReportHistory] = useState([]);
const [selectedPatientReportVersion, setSelectedPatientReportVersion] = useState(null);
const finalNoteContentRef = useRef();

const assessmentFileCategories = [
  { category: 'Labs', files: [
    { id: 5, fileName: 'Basic Gastro Labs', url: BasicGastroLabs },
    { id: 3, fileName: 'Anemia Labs', url: AnemiaLabs },
    { id: 14, fileName: 'Heaptic Labs', url: HeapticLabs },
    { id: 19, fileName: 'Stool Studies', url: StoolStudies },
  ]},
  { category: 'Imaging', files: [
    { id: 1, fileName: 'Abdominal CT', url: AbdominalCT },
    { id: 2, fileName: 'Abdominal US', url: AbdominalUS },
    { id: 4, fileName: 'Barium Studies', url: BariumStudies },
  ]},
  { category: 'Procedure', files: [
    { id: 10, fileName: 'EGD Order', url: EGDOrder },
    { id: 6, fileName: 'Colon Order', url: ColonOrder },
    { id: 7, fileName: 'Colonoscopy', url: Colonoscopy },
    { id: 22, fileName: 'Upper GI Endoscopy', url: UpperGIEndoscopy },
    { id: 18, fileName: 'Procedural Sedation', url: ProceduralSedation },
    { id: 8, fileName: 'Colon Screening Guidelines', url: ColonScreeningGuidelines },
    { id: 21, fileName: 'Telehealth Disclaimer', url: TelehealthDisclaimer },
  ]},
  { category: 'Diet & Lifestyle Modification', files: [
    { id: 23, fileName: 'Weight Reducing Diet', url: Weight_Reducing_Diet },
    { id: 15, fileName: 'High Fiber Diet', url: High_Fiber_Diet },
    { id: 13, fileName: 'GERD and Lifestyle', url: GERD_Diet_and_Lifestyle },
    { id: 20, fileName: 'Stress Management', url: StressManagement },
    { id: 11, fileName: 'FattyLiver', url: FattyLiver },
    { id: 9, fileName: 'Diverticulosis', url: Diverticulosis },
    { id: 17, fileName: 'Irritable Bowel Syndrome', url: IrritableBowelSyndrome },
    { id: 16, fileName: 'Inflammatory Bowel Disease', url: InflammatoryBowelDisease },
  ]},
];
const assessmentFileArray = assessmentFileCategories.flatMap((cat) => cat.files);

const [SessionIDCheck, setSessionIDCheck] = useState('');
const [reportData, setReportData] = useState(null);
const [checkFollowupMeet, setCheckFollowupMeet] = useState(false); 
const [checkAllFollowupMeet, setCheckAllFollowupMeet] = useState(false); 

useEffect(() => {
  if (UserId) {
    setuserid(UserId);
  }
}, [UserId]);
const [selectedItemFollowup, setSelectedItemFollowup] = useState([]); // Followup Date   
const [checkPhysicalExam, setCheckPhysicalExam] = useState(false); // Track if the div is open
const [bpMMTxt, setbpMMTxt] = useState('');
const [bpHgTxt, setbpHgTxt] = useState('');
const [heartrateTxt, setheartrateTxt] = useState('');
const [selectedItem, setSelectedItem] = useState(null); // Button name
const [openDiv, setOpenDiv] = useState(null);
const [followupZoomMeet, setFollowupZoomMeet] = useState(false);
const [followupMeetingDone, setFollowupMeetingDone] = useState(false);
const [checkZoomMeet, setCheckZoomMeet] = useState(false);
const [selectedZoomMeet, setSelectedZoomMeet] = useState([]); // Button name    
const [isOpenFollowup, setIsOpenFollowup] = useState(false); // Track if the div is open
const [checkFollowup, setCheckFollowup] = useState(false); // Track if the div is open
const [filledCheckFollowup, setfilledCheckFollowup] = useState(false); // Track if the div is open
const [followupDays, setFollowupDays] =  useState(new Date()); //useState('');
const [futureDate, setFutureDate] = useState(null);
const [remainingDays, setRemainingDays] = useState(null);
const now = new Date();
const [errorMessage, setErrorMessage] = useState('');

// console.log(followupZoomMeet +'  -  '+ selectedItemFollowup +'  -  '+ JSON.stringify(selectedZoomMeet))

const [errors, setErrors] = useState({}); 
const [activeSpeech, setActiveSpeech] = useState(null);
const [transcripts, setTranscripts] = useState({ medicalcondition: ''});
const { transcript, resetTranscript, listening, browserSupportsSpeechRecognition } = useSpeechRecognition();
const socket = useRef(null);
const recorder = useRef(null);
const streamRef = useRef(null);
const [isRecording, setIsRecording] = useState({medicalcondition: false,});
const [activeMic, setActiveMic] = useState(null); 
const [isConnecting, setIsConnecting] = useState(false);
const [MedicalConditionsData, setMedicalConditionsData] = useState('');
const [MedicalConditionFile, setMedicalConditionFile] = useState(null);
const [fileNameMedicalCondition, setFileNameMedicalCondition] = useState('');
const [medicalConditionSuggestions, setMedicalConditionSuggestions] = useState([]); 


 
const [FollowupData, setFollowupData] = useState([]); // Followup Date 

const [activeOption, setActiveOption] = useState('Routine'); // State to track the active option
const [PCP_Pharmacy, setPCP_Pharmacy] = useState(null);
 
const handleOptionClick = (option) => {
  setActiveOption(option); // Update the active option
};

 // Reset to page 1 when the component loads
  // useEffect(() => {
  //   setCurrentPage(1);
  // }, []);

 

 

const checkOrderList = [
  { Name: "Allergies", doc_type: "allergy" },
  { Name: "Medications", doc_type: "medications" },
  { Name: "Medical Conditions", doc_type: "medical_conditions" },
  { Name: "Past Surgical History", doc_type: "past_surgical_history" },
  { Name: "Social History", doc_type: "social_history" },
  { Name: "Primary Care Physician (PCP)", doc_type: "pcp" },
  { Name: "Pharmacy information", doc_type: "pharmacy" },
  { Name: "Upload Reports", doc_type: "other_report" }
];

const options = [
  'Test Results',
  'Refills',
  'Recall Colon',
  'Recall ECD',
  'Routine',
  'Persistant Symptoms',
];

const formatConsultationDate = (createdOn, createdAt) => {
  const value = createdOn || createdAt;
  if (!value) return '-';
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format('MMM DD, YYYY') : '-';
};

const toggleDivFollowup = () => {
  setCheckFollowup(false);    
  setOpenDiv(openDiv === 'Followup' ? null : 'Followup');
};

// Handle cancel button click
const closeFollowup = () => {
  setCheckFollowup(false); // Close the div without saving  
    setOpenDiv('') 
    setErrors({});       
    setErrorMessage(''); 
};
 // Handle cancel button click
 const handleCancelFollowup = () => {
  setIsOpenFollowup(false); // Close the div without saving 
    // Reset temporary input values 
    setFollowupDays(''); 
    setFutureDate('');
    setOpenDiv('')
    // Clear any errors
    setErrors({}); 
    setErrorMessage('');
    setLoading(false);
};
 
  // Handle form submission
  const handleSaveFollowup = async (event) => { 
    event.preventDefault();
    setLoading(true);
  
    let formErrors = {};
    // setErrorMessage('');
  
    // if (!followupDays.trim()) {
   if (!followupDays || (typeof followupDays === 'string' && !followupDays.trim())) {
    formErrors.followupDays = 'Please enter follow-up days';
    }
  
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      setLoading(false);
      return;
    }
  
    setShowLoader(true);
  
    const data = {
      admin_id: adminId,
      session_id: SessionIDCheck,
      user_id: userid,
      follow_up_date: followupDays,
    };
  
    try {
      await updateChatSession(SessionIDCheck, { follow_up_date: followupDays });
      toast.success('Data updated successfully!', { position: toast.POSITION.TOP_RIGHT });
      setSelectedItemFollowup(futureDate);
      setFollowupDays('');
      setFutureDate('');
      setOpenDiv(null);
      setErrors({});
      setLoading(false);
      setShowLoader(false);
    } catch (error) {
      logger.error('Error:', error);
      toast.error('Network error. Please try again later.', { position: toast.POSITION.TOP_RIGHT });
      setLoading(false);
      setShowLoader(false);
    }
  };
 
// useEffect(() => {
// if (searchQuery) {
//   navigate('/admin/dashboard');
// }
// }, [searchQuery, navigate]);

// Fetch illnesses
const illnessesArray = async () => {
  try {
    const illnesses = await getIllnesses();
    setIllnessesList(illnesses);
  } catch (error) {
    logger.error('Error fetching illnesses:', error);
  }
};

const handleRecordsPerPageChange = (event) => {
setRecordsPerPage(Number(event.target.value));
setCurrentPage(1);
};

const handlePageChange = (page) => {
  if (page < 1 || page > totalPages) return;
setCurrentPage(page);
navigate(location.pathname, { state: { currentPage: page } });
};

const handlePrevGroup = () => {
  if (currentPageGroup > 1) {
    setCurrentPageGroup(currentPageGroup - 1);
    setCurrentPage((currentPageGroup - 2) * 3 + 1);
  }
};

const handleNextGroup = () => { 
  const maxGroup = Math.ceil(totalPages / 3);
  if (currentPageGroup < maxGroup) {
    setCurrentPageGroup(currentPageGroup + 1);
    setCurrentPage(currentPageGroup * 3 + 1); 
  }
};

const handleFindRecord = (id) => {

};
const handleShowSummary = async (session_id) => { 
  // console.log(id)
goToPatientHistory(session_id) 
setShowLoaderPage(true)
const foundRecord = UserHistoryData.find((item) => (item.session_id || item.id) === session_id); 
if (foundRecord) { 
  const filteredConversation = foundRecord.conversation.filter(convo => Object.keys(convo).length !== 0); 
  setRecordData(foundRecord);
  setSelectedIllness(foundRecord.illness) 
  setChatHistory(filteredConversation)  
  setPlanOnCareData(foundRecord.plan_of_care)
  setConditionalDiagnosis(foundRecord.conditional_diagnosis);
  setFinalConsultantNote(foundRecord.final_consultant_note || '');
  setFinalConsultantDiagnosis(foundRecord.final_consultant_diagnosis || '');
  setFinalConsultantPlan(foundRecord.final_consultant_plan || '');
  setFinalConsultantHPI(foundRecord.final_consultant_hpi || '');
  setFinalConsultantPMH(foundRecord.final_consultant_pmh || '');
  setFinalConsultantMedications(foundRecord.final_consultant_medications || '');
  setFinalConsultantAllergies(foundRecord.final_consultant_allergies || '');
  setFinalConsultantSocialHistory(foundRecord.final_consultant_social_history || '');
  setFinalConsultantROS(foundRecord.final_consultant_ros || '');
  setDoctorRecommendations(foundRecord.doctor_recommendations || []);
  setIsFinalNoteSubmitted(foundRecord.is_final_note_submitted || false);
  setPatientReportHistory([]);
  setSelectedPatientReportVersion(null);
  // Always load report history — there may be previously submitted versions
  // even if the latest note is not yet submitted (e.g. after followup generation)
  loadPatientReportHistory(foundRecord.session_id || foundRecord.id);
  // Load selected Assessment & Plan files
  const savedFileIds = foundRecord?.selected_final_note_file_ids || [];
  if (savedFileIds.length > 0) {
    const restoredFiles = assessmentFileArray.filter((f) => savedFileIds.includes(f.id));
    setSelectedFinalNoteFiles(restoredFiles);
  } else {
    setSelectedFinalNoteFiles([]);
  }
  setSessionIDCheck(foundRecord.session_id)
  // setSelectedItemFollowup(foundRecord.follow_up_date ? foundRecord.follow_up_date  : '')
  setCheckPhysicalExam(foundRecord.bp_hg ? 'true'  : 'false')
  setbpHgTxt(foundRecord.bp_hg ? foundRecord.bp_hg : '')
  setbpMMTxt(foundRecord.bp_mm ? foundRecord.bp_mm  : '')
  setheartrateTxt(foundRecord.heartrate ? foundRecord.heartrate : '')
  setSelectedItem(foundRecord.patientstatus)
  setSelectedZoomMeet(foundRecord.zoom_meeting || null) 
  // Check if the answer to the specific question is "yes"
  const emergencyQuestion = filteredConversation.find(convo => 
    convo.question === "Do you need emergency care? (YES/NO)" && convo.answer.toLowerCase() === "yes"
  );

  
  if (emergencyQuestion) {
    // alert("Emergency care is needed!");
    setEmergencyQuest(true)
  } 
  setChatHistory([]);
  setShowSummary(true)   
  if(foundRecord.session){ 
    // adminCheckedSession(foundRecord.user_id, foundRecord.session_id)
  }
  
} else {
  setRecordData(null); 
}
try {
  const followupData = await getAllFollowupRequests(foundRecord.session_id);
  if (Array.isArray(followupData) && followupData.length > 0) {
    setFollowupData(followupData);
  } else {
    setFollowupData([]);
  }
} catch (error) {
  setFollowupData([]);
}

// Reset followup states before evaluating the active request
setFollowupZoomMeet(false);
setFollowupMeetingDone(false);

try {
  const activeRequest = await getActiveFollowupRequest(foundRecord.session_id);
  if (activeRequest) {
    const { activeFlag, data } = activeRequest;
    setCheckAllFollowupMeet(activeFlag);
    setSelectedItemFollowup(data);
    if (data?.zoom_meeting && Object.keys(data.zoom_meeting).length > 0) {
      setFollowupZoomMeet(true);
      const ms = data.zoom_meeting.meeting_status;
      if (ms === 'completed' || ms === 'ended' || data.status === 'completed') {
        setFollowupMeetingDone(true);
      }
    }
    setCheckFollowupMeet(activeFlag);
  } else {
    setCheckAllFollowupMeet(false);
    setCheckFollowupMeet(false);
  }
} catch (error) {
  setCheckAllFollowupMeet(false);
  setCheckFollowupMeet(false);
}

try {
  const illnesses = await getIllnesses();
  setIllnessesList(illnesses);
  setShowLoaderPage(false);
} catch (error) {
  logger.error('Error fetching illnesses:', error);
}
// Only fetch reports if reports_id exists
if (foundRecord.reports_id) {
  try {
    const reports = await getMedicalReports(foundRecord.reports_id, userid);
    setReportData(reports || []);
  } catch (error) {
    logger.error('Error fetching medical reports:', error);
  }

  try {
    const pcpPharmacy = await getPCPPharmacyDetails(foundRecord.reports_id);
    setPCP_Pharmacy(pcpPharmacy || null);
  } catch (error) {
    logger.error('Error fetching PCP/Pharmacy details:', error);
  }
} else {
  // Reset report data if no reports_id
  setReportData(null);
  setPCP_Pharmacy(null);
}

};
// Group reportData by doc_type
const groupedDocuments = (reportData || []).reduce((acc, doc) => {
  if (!doc.doc_type) {
    return acc;
  }
  const docType = doc.doc_type.trim();

  if (!acc[docType]) {
    acc[docType] = [];
  }

  acc[docType].push({
    doc_id: doc.doc_id,
    doc_summary: doc.doc_summary,
    doc_text: doc.doc_text,
    doc_url: doc.doc_url,
  });


return acc;
}, {});


 
if (PCP_Pharmacy && PCP_Pharmacy.pcp && PCP_Pharmacy.pcp.name && PCP_Pharmacy.pcp.address) {
  groupedDocuments["pcp"] = [
    ...(groupedDocuments["pcp"] || []),
    {
      doc_summary: `${PCP_Pharmacy.pcp.name}, ${PCP_Pharmacy.pcp.address}`,  
      doc_text: null,
      doc_url: null,
    },
  ];
  }
  // Push Pharmacy into groupedDocumentspharmacy
  if (PCP_Pharmacy && PCP_Pharmacy.pharmacy && PCP_Pharmacy.pharmacy.name && PCP_Pharmacy.pharmacy.address) {
  groupedDocuments["pharmacy"] = [
    ...(groupedDocuments["pharmacy"] || []),
    {
       doc_summary: `${PCP_Pharmacy.pharmacy.name}, ${PCP_Pharmacy.pharmacy.address}`,
       doc_text: null,
       doc_url: null,
    },
  ];
  }  
  
  

// Map checkOrderList to match groupedDocuments and sort by order
const sortedGroupedDocuments = checkOrderList.map(orderItem => ({
Name: orderItem.Name,
doc_type: orderItem.doc_type,
documents: groupedDocuments[orderItem.doc_type] || []
}));

const adminCheckedSession = async (patientId, sessionId) => {
try {
  await createAdminLog({ patient_id: patientId, admin_id: adminId, session_id: sessionId });
  setBackReload(true);
} catch (error) {
  logger.error('Error fetching data:', error);
  setShowLoader(false);
}
}

const handleShowChat = (id) => {
const filteredConversation = RecordData.conversation.filter(convo => Object.keys(convo).length !== 0);

setActiveTab(id);
setAnswerLoader(true)
setTimeout(() =>  { 
  setChatHistory(filteredConversation); 
  setAnswerLoader(false) 
}, 1000);
}
const handleHideSummary = () => { 
setActiveTab(0);
setRecordData([])
setSelectedIllness() 
if(BackReload){
  window.location.reload(); 
}
setShowSummary(false)
setAnswerLoader(false) 
setEmergencyQuest(false)
};

const handleShowDashboard = () => {
setShowSummary(false)
// routeChange()
};
// GI/PCP internal workflow statuses — hidden from patients, original status shown otherwise
const GI_PCP_STATUSES = new Set(['shared_with_pcp', 'in_review', 'under_review', 'approved', 'needs_signature']);

const patientStatusLabel = (status) => {
  if (!status) return 'Pending';
  if (GI_PCP_STATUSES.has(status)) return 'Pending';
  return status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ');
};

const patientStatusClass = (status) => {
  if (!status || GI_PCP_STATUSES.has(status)) return 'colorpending';
  return `color${status}`;
};

const renderTableBody = () => {
const start = (currentPage - 1) * recordsPerPage;
const end = start + recordsPerPage;
const pageData = UserHistoryData?.slice(start, end);

return pageData.map((UserHistoryData, index) => (
  <tr key={index}  onClick={() => handleShowSummary(UserHistoryData.session_id || UserHistoryData.id )} style={{cursor:'pointer'}}>
    <td><span className="d-flex align-items-center"><img src={Icons[0].admin_listIcon} style={{marginRight:'10px'}}/>{UserHistoryData.illness}</span></td>


    <td style={{textAlign:'center'}}>
      {UserHistoryData.weight || UserHistoryData.height ? (
        <>
        {UserHistoryData.height ?`${formatHeight(UserHistoryData.height)}  / ` : null}
        {UserHistoryData.weight ?`${UserHistoryData.weight} lbs` : null}
        </>
        ) : (
          "-"
        )}
  </td>
    <td style={{textAlign:'center'}}> {formatConsultationDate(UserHistoryData.created_on, UserHistoryData.created_at)}</td>
     <td style={{textAlign:'center'}}>
       <span className={`selectedItemBtn ${patientStatusClass(UserHistoryData.patientstatus)}`} style={{margin:'auto'}}>
         {patientStatusLabel(UserHistoryData.patientstatus)}
       </span>
     </td>
    <td style={{textAlign:'right'}}> <button className="viewBtnClass">View</button></td>
  </tr>
));

 
};

const renderPagination = () => { let pages = [];
  const startPage = (Math.floor((currentPage - 1) / 3) * 3) + 1;
  const endPage = Math.min(startPage + 2, totalPages);

  for (let i = startPage; i <= endPage; i++) {
    pages.push(
      <button
        key={i}
        className={`page-button ${i === currentPage ? 'active' : ''}`}
        onClick={() => handlePageChange(i)}
      >
        {i}
      </button>
    );
  }

  return (
    <div className="pagination">
      <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
        Previous
      </button>
      {pages}
      <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
        Next
      </button>
    </div>
  );;
};
 


useEffect(() => {
if (!userid) {
  return;
}
const fetchRecords = async () => {

  setShowLoaderPage(true)

  try {
    const sessionData = await getUserSessions(userid);
    if (!sessionData) {
      setShowLoaderPage(false);
      return;
    }
    setShowLoaderPage(true);
    const sortedHistory = [...(sessionData.history || [])]
      .map((item) => ({
        ...item,
        session_id: item.session_id || item.id || '',
        created_on: item.created_on || item.created_at || null
      }))
      .sort((a, b) => {
        const aDate = new Date(a.created_on || a.created_at || 0);
        const bDate = new Date(b.created_on || b.created_at || 0);
        return bDate - aDate;
      });
    setUserHistoryData(sortedHistory);
    setUserHistoryNumber(sortedHistory.length);
    setTotalRecords(sortedHistory.length);
    setBMITxt(sessionData.bmi ? sessionData.bmi : 0);
    setFullName(sessionData.user_details?.fullName || '');
    setEmail(sessionData.user_details?.email || '');
    setDOBTxt(sessionData.user_details?.dob || '');
    setPhoneNumber(sessionData.user_details?.phoneNumber ? (sessionData.user_details.phoneNumber.startsWith('+') ? sessionData.user_details.phoneNumber : '+' + sessionData.user_details.phoneNumber) : '');
    setUserProfile(sessionData.user_details?.userProfile || '');
    setInsuranceIdTxt(sessionData.user_details?.insurance ? sessionData.user_details.insurance : 0);
    setGenderTxt(sessionData.user_details?.gender ? sessionData.user_details.gender : '');
    setHeightTxt(sessionData.user_details?.height ? sessionData.user_details.height : 0);
    setWeightTxt(sessionData.user_details?.weight ? sessionData.user_details.weight : 0);
    setIsSession(sessionData.session_status ? sessionData.session_status : 'false');
 
  } catch (error) {
    logger.error('Error fetching records:', error);
    // Handle error, show an error message, etc.
  }
  
  setShowLoaderPage(false)
};
fetchRecords();
}, [userid]); 

useEffect(() => {
const handlePopstate = () => {
  setActiveTab(0); // Reset the active tab to the default tab index
};

window.addEventListener('popstate', handlePopstate);

return () => {
  window.removeEventListener('popstate', handlePopstate);
};
}, []);

// Cleanup recorder, socket, and media stream on unmount
useEffect(() => {
  return () => {
    if (recorder.current) {
      recorder.current.stopRecording(() => { recorder.current = null; });
    }
    if (socket.current) {
      socket.current.close();
      socket.current = null;
    }
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
  };
}, []);

const handleTabClick = (index) => {
setActiveTab(index);
setShowMainPoint(false);
};

useEffect(() => {
setActiveTab(0); // Set the default active tab when the component mounts
}, []);

const loadPatientReportHistory = async (sessionId) => {
  if (!sessionId) return;
  try {
    const res = await fetchWithAppCheck(
      'https://us-central1-aigicare-prod.cloudfunctions.net/getReportHistory',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: sessionId }),
      }
    );
    const data = await res.json();
    if (data.versions && data.versions.length > 0) {
      // Patient only sees versions that admin has explicitly submitted
      const submittedVersions = data.versions.filter(v => v.submitted === true);
      setPatientReportHistory(submittedVersions);

      // If root doc is_final_note_submitted is false (e.g. after followup generation)
      // but there are previously submitted versions, show the latest submitted version
      if (submittedVersions.length > 0) {
        setIsFinalNoteSubmitted(true);
        // Load the latest submitted version's content so patient sees correct data
        const latestSubmitted = submittedVersions[0]; // sorted desc by version
        setFinalConsultantNote(latestSubmitted.final_consultant_note || '');
        setFinalConsultantHPI(latestSubmitted.final_consultant_hpi || '');
        setFinalConsultantPMH(latestSubmitted.final_consultant_pmh || '');
        setFinalConsultantMedications(latestSubmitted.final_consultant_medications || '');
        setFinalConsultantAllergies(latestSubmitted.final_consultant_allergies || '');
        setFinalConsultantSocialHistory(latestSubmitted.final_consultant_social_history || '');
        setFinalConsultantROS(latestSubmitted.final_consultant_ros || '');
      }
    }
  } catch (err) {
    // non-critical — version history is supplemental
  }
};

const handleViewPatientReportVersion = (version) => {
  if (!version) {
    setSelectedPatientReportVersion(null);
    // Restore latest submitted version's content (not root doc which may have unsubmitted data)
    if (patientReportHistory.length > 0) {
      const latestSubmitted = patientReportHistory[0];
      setFinalConsultantNote(latestSubmitted.final_consultant_note || '');
      setFinalConsultantHPI(latestSubmitted.final_consultant_hpi || '');
      setFinalConsultantPMH(latestSubmitted.final_consultant_pmh || '');
      setFinalConsultantMedications(latestSubmitted.final_consultant_medications || '');
      setFinalConsultantAllergies(latestSubmitted.final_consultant_allergies || '');
      setFinalConsultantSocialHistory(latestSubmitted.final_consultant_social_history || '');
      setFinalConsultantROS(latestSubmitted.final_consultant_ros || '');
    } else {
      const rec = UserHistoryData.find(item => (item.session_id || item.id) === SessionIDCheck);
      if (rec) {
        setFinalConsultantNote(rec.final_consultant_note || '');
        setFinalConsultantHPI(rec.final_consultant_hpi || '');
        setFinalConsultantPMH(rec.final_consultant_pmh || '');
        setFinalConsultantMedications(rec.final_consultant_medications || '');
        setFinalConsultantAllergies(rec.final_consultant_allergies || '');
        setFinalConsultantSocialHistory(rec.final_consultant_social_history || '');
        setFinalConsultantROS(rec.final_consultant_ros || '');
      }
    }
    return;
  }
  const item = patientReportHistory.find(h => h.version === parseInt(version));
  if (item) {
    setSelectedPatientReportVersion(parseInt(version));
    setFinalConsultantNote(item.final_consultant_note || '');
    setFinalConsultantHPI(item.final_consultant_hpi || '');
    setFinalConsultantPMH(item.final_consultant_pmh || '');
    setFinalConsultantMedications(item.final_consultant_medications || '');
    setFinalConsultantAllergies(item.final_consultant_allergies || '');
    setFinalConsultantSocialHistory(item.final_consultant_social_history || '');
    setFinalConsultantROS(item.final_consultant_ros || '');
  }
};

const downloadFinalNotePdf = async () => {
  try {
    setIsGeneratingPdf(true);
    const now = new Date();
    const date = now.toISOString().split("T")[0];
    const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
    const sanitizedName = (fullName || 'Patient').replace(/ /g, "_");
    const filename = `${date}_${time}_${sanitizedName}_FinalNote`;
    const content = finalNoteContentRef.current;
    const headerImageUrl = Icons[0].headerImageUrlLink;
    const footerImageUrl = Icons[0].footerImageUrlLink;

    if (!content) {
      toast.error("Content not found!", { position: toast.POSITION.TOP_RIGHT });
      return;
    }

    const options = {
      margin: [1.47, 0.2, 1.1, 0.2],
      filename: filename,
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
      html2canvas: { scale: 2, useCORS: true, letterRendering: true },
    };

    const contentPdfBlob = await html2pdf().set(options).from(content).toPdf().outputPdf('blob');
    const contentPdfDoc = await PDFDocument.load(await contentPdfBlob.arrayBuffer());
    const mergedPdfDoc = await PDFDocument.create();

    const contentPages = await mergedPdfDoc.copyPages(contentPdfDoc, contentPdfDoc.getPageIndices());
    contentPages.forEach((page) => mergedPdfDoc.addPage(page));

    // Add headers and footers
    const totalPages = mergedPdfDoc.getPageCount();
    const headerImageBytes = await fetch(headerImageUrl).then((r) => r.arrayBuffer());
    const footerImageBytes = await fetch(footerImageUrl).then((r) => r.arrayBuffer());
    const headerImage = await mergedPdfDoc.embedPng(headerImageBytes);
    const footerImage = await mergedPdfDoc.embedPng(footerImageBytes);

    for (let i = 0; i < totalPages; i++) {
      const page = mergedPdfDoc.getPage(i);
      const { width, height } = page.getSize();
      page.drawImage(headerImage, { x: 0, y: height - 50, width: width, height: 50 });
      page.drawText(`Page ${i + 1} of ${totalPages}`, { x: width - 70, y: height - 15, size: 10 });
      page.drawImage(footerImage, { x: 0, y: 0, width: width, height: 25 });
    }

    const mergedPdfBytes = await mergedPdfDoc.save();
    const mergedBlob = new Blob([mergedPdfBytes], { type: "application/pdf" });
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(mergedBlob);
    downloadLink.download = filename + '.pdf';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    toast.success("PDF downloaded!", { position: toast.POSITION.TOP_RIGHT });
  } catch (err) {
    logger.error("Final note PDF error:", err);
    toast.error("Failed to generate PDF.", { position: toast.POSITION.TOP_RIGHT });
  } finally {
    setIsGeneratingPdf(false);
  }
};

// Function to process the user data
const processUserData = () => {
if (!RecordData) return []; // If no recordData, return empty array

return [RecordData].map(user => {
  // Remove empty objects from the conversation array
  const filteredConversation = user.conversation.filter(convo => Object.keys(convo).length !== 0); 
  
  // Check if the answer to the specific question is "yes"
  const emergencyQuestion = filteredConversation.find(convo => 
    convo.question === "Do you need emergency care? (YES/NO)" && convo.answer.toLowerCase() === "yes"
  );

  if (emergencyQuestion) {
    alert("Emergency care is needed!");
  }

  return {
    ...user,
    conversation: filteredConversation
  };
});
};
const [ImageHide, setImageHide] = useState(false); 
const [showMainPoint, setShowMainPoint] = useState(false);
const handleInputMainPoint = () => { 
    setShowMainPoint(false);   
    {!PlanOnCareData ? 
    (<>
      setShowMainPoint(false);
      </>
    ):(
      <>
      setShowMainPoint(true);
      </>
    )
  }
setShowMainPoint(true);
setPlanOnCareData(PlanOnCareData);
};
const handleCancelClickMPoint = () => {
setShowLoader(false);
setShowMainPoint(false);
};
const handleInputChangeMPoint= (e) => {
setPlanOnCareData(e.target.value);
};
const handleSaveClickMPoint = () => {
setShowLoader(true);
setTimeout(() => { 
setIsEditing(false); 
handleSaveMPoint();
}, 2000); 
};
const handleSaveMPoint = async (event) => {   
try {   
  const reqData = JSON.stringify({ session_id: SessionIDCheck, plan_of_care: PlanOnCareData }) ;

  await updateChatSession(SessionIDCheck, { plan_of_care: PlanOnCareData });
  setShowLoader(false);
  setShowMainPoint(false);
  setBackReload(true);
} catch (error) {
  logger.error('Error updating summary:', error);
  // Handle error, show an error message, etc.
}
};

const [showMainPointCD, setShowMainPointCD] = useState(false);

//conditionaldiagnosis  
const handleInputMainPointCD = () => { 
  setShowMainPointCD(false);   
  {!ConditionalDiagnosis ? 
  (<>
    setShowMainPointCD(false);
    </>
  ):(
    <>
    setShowMainPointCD(true);
    </>
  )
}
setShowMainPointCD(true);
setConditionalDiagnosis(ConditionalDiagnosis);
};
const handleCancelClickMPointCD = () => {
setShowLoader(false);
setShowMainPointCD(false);
};
const handleInputChangeMPointCD = (e) => {
setConditionalDiagnosis(e.target.value);
};
const handleSaveClickMPointCD = () => {
setShowLoader(true);
setTimeout(() => { 
setIsEditingCD(false); 
handleSaveMPointCD();
}, 2000); 
};
const handleSaveMPointCD = async (event) => {   
// try {   
const data = { 
  admin_id: adminId,
  session_id : SessionIDCheck,   
  user_id: userid, 
  conditional_diagnosis: ConditionalDiagnosis , 
};  
try {
  await updateChatSession(SessionIDCheck, { conditional_diagnosis: ConditionalDiagnosis });
  toast.success('Conditional diagnosis updated successfully.', { position: toast.POSITION.TOP_RIGHT });
  setShowLoader(false);
  setShowMainPointCD(false);
  setBackReload(true);
} catch (error) {
  logger.error('Error:', error);
  toast.error('An unexpected error occurred.');
} finally {
  setLoading(false);
}


};

//  --------------------------------------------------

useEffect(() => {
  handleMyInsurance(UserId)
  const ageCal = moment().diff(userProfileData.dob, 'years'); 
  setAgeTxt(userProfileData.dob ? ageCal : '');   

  localStorage.setItem('UserId', JSON.stringify(UserId));
 
}, [UserId]);

const handleMyInsurance = async (UserIdNew) => {  
  try {
    const insuranceList = await getInsuranceData(UserIdNew);
    if (insuranceList && insuranceList.length > 0) {
      const insurance = insuranceList[0];
      localStorage.setItem('myinsuranceinfo', JSON.stringify(insurance));
      setMyinsuranceinfo(insurance);
      const currentDate = moment();
      const expiry = moment(insurance.expiry_date);
      setCheckExpiry(expiry.isBefore(currentDate, 'day'));
    }
  } catch (error) {
    logger.error('Error fetching insurance:', error);
  }
}; 
const [documents, setDocuments] = useState([]); // Document list state
const [isModalOpen, setIsModalOpen] = useState(false); // Modal open/close state
const [selectedDocument, setSelectedDocument] = useState(null); // Track the selected document

// Open modal and set selected document
const openModal = (doc) => { 
  setSelectedDocument(doc);
  setIsModalOpen(true);
};

// Close modal and reset selected document
const closeModal = () => {
  setIsModalOpen(false);
  setSelectedDocument(null);
};

// Add document dynamically
const addDocument = (name, url) => {
  const newDocument = { name, url };
  setDocuments([...documents, newDocument]); // Add to the document list
};
const handleButtonClickFollowZoomMeet = () => {
  const zoomSchedulerUrl = selectedItemFollowup.zoom_meeting.session_link || selectedItemFollowup.zoom_meeting.patient_url;
  window.open(zoomSchedulerUrl, "_blank", "noopener,noreferrer");
};

const toggleDivZoomMeet = () => {
  setCheckZoomMeet(false);    
  setOpenDiv(openDiv === 'ZoomMeet' ? null : 'ZoomMeet');
};
const handleButtonClickZoomMeet = () => {
  const zoomSchedulerUrl = selectedZoomMeet.session_link || selectedZoomMeet.patient_url;
  window.open(zoomSchedulerUrl, "_blank", "noopener,noreferrer");
};

const getToken = async () => {
  const response = await fetchWithAppCheck('https://us-central1-aigicare-prod.cloudfunctions.net/getAssemblyAIToken');
  const data = await response.json();
  if (data.error || data.status === 'error') {
    return null;
  }
  return data.token;
};

const generateTranscript = async (targetTextArea) => {
  try {
    const token = await getToken();
    if (!token) return;
    setIsConnecting(true);
    socket.current = new WebSocket(`wss://api.assemblyai.com/v2/realtime/ws?sample_rate=16000&token=${token}`);

    const texts = {};
    socket.current.onmessage = (voicePrompt) => {
     // let msg = '';
      let msg = transcripts[targetTextArea] || ''; 
      const res = JSON.parse(voicePrompt.data);
      if (res.text && res.text.trim() !== '') {  // Check if res.text is not null or blank
        texts[res.audio_start] = res.text;
      }
      // texts[res.audio_start] = res.text;
      const keys = Object.keys(texts).filter(key => key !== 'undefined').sort((a, b) => a - b);
      keys.forEach((key) => {
        msg += ` ${texts[key]}`;
      });

      setTranscripts((prevState) => ({
        ...prevState,
        [targetTextArea]: msg.trim(), // || '',
      }));
    };

    socket.current.onerror = (event) => {
     // logger.error('WebSocket error:', event);
      socket.current.close();
      socket.current = null;
      setIsConnecting(false);
    };

    socket.current.onclose = (event) => { 
      socket.current = null;
      setIsConnecting(false);
    };

    socket.current.onopen = () => {
      setIsConnecting(false);
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then((stream) => {
          streamRef.current = stream;
          recorder.current = new RecordRTC(stream, {
            type: 'audio',
            mimeType: 'audio/webm;codecs=pcm',
            recorderType: RecordRTC.StereoAudioRecorder,
            timeSlice: 250,
            desiredSampRate: 16000,
            numberOfAudioChannels: 1,
            bufferSize: 4096,
            audioBitsPerSecond: 128000,
            ondataavailable: (blob) => {
              const reader = new FileReader();
              reader.onload = () => {
                const base64data = reader.result;
                if (socket.current) {
                  socket.current.send(JSON.stringify({ audio_data: base64data.split('base64,')[1] }));
                }
              };
              reader.readAsDataURL(blob);
            },
          });
          recorder.current.startRecording();
        })
        .catch((err) => logger.error('getUserMedia error:', err));
    };

    setIsRecording((prevState) => ({
      ...prevState,
      [targetTextArea]: true,
    }));

    setActiveMic(targetTextArea);
  } catch (error) {
    logger.error('Error generating transcript:', error);
  }
};

const endTranscription = (targetTextArea) => {
  if (socket.current) {
    socket.current.send(JSON.stringify({ terminate_session: true }));
    socket.current.close();
    socket.current = null;
  }

  if (recorder.current) {
    recorder.current.stopRecording();
    recorder.current = null;
  }
  if (streamRef.current) {
    streamRef.current.getTracks().forEach(track => track.stop());
    streamRef.current = null;
  }

  setIsRecording((prevState) => ({
    ...prevState,
    [targetTextArea]: false,
  }));

  setActiveMic(null);
};


const handleMicClick = (targetTextArea) => {
  if (isConnecting) { 
   // console.log('Connecting, please wait...');
    return;
  }
  if (activeMic === targetTextArea) {
    endTranscription(targetTextArea);
  } else {
    if (activeMic) {
      endTranscription(activeMic);
    }
    generateTranscript(targetTextArea);
  }
};

const handleTextChangeMedicalCondition = (e) => {   
  setTranscripts({ ...transcripts, medicalcondition: e.target.value });     
  const valueTxt =  e.target.value;
  setMedicalConditionsData(valueTxt);    
};
 
  const [statusMessage, setStatusMessage] = useState("");

  const handleFollowUpSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (!activeOption || !transcripts.medicalcondition) {
      setStatusMessage("400 Bad Request: Missing required fields.");
      return;
    }

    const requestBody = {
      session_id:  SessionIDCheck,
      user_id: userid, // Pass the session ID 
      description: transcripts.medicalcondition, // Description from transcripts
      title: activeOption,   // Title from the active option
    };

    setLoading(true);
    setStatusMessage(""); // Reset status message

    try {
      const docRef = await addDoc(collection(db, 'followup_requests'), {
        ...requestBody,
        status: 'active',
        created_at: new Date().toISOString(),
      });
      const savedData = { id: docRef.id, ...requestBody };
      setStatusMessage("200 OK: Followup request created successfully.");
      setSelectedItemFollowup(savedData);
      setCheckFollowupMeet(true);
      setOpenDiv(null);
      setErrors({});
      setLoading(false);
      setShowLoader(false);
    } catch (error) {
      logger.error('Error creating followup request:', error);
      setStatusMessage("Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };


  const calculateDuration = (startTs, endTs) => { 
    const durationInSeconds = endTs - startTs;
    const durationInMinutes = Math.floor(durationInSeconds / 60);
    const hours = Math.floor(durationInMinutes / 60);
    const minutes = durationInMinutes % 60;
  
    const hourString = hours > 0 ? `${hours} hour` : "";
    const minuteString = minutes > 0 ? `${minutes} minute` : "";
  
    return [hourString, minuteString].filter(Boolean).join(" and ");
  };

  const getOrdinalLabel = (number) => {
    const j = number % 10;
    const k = number % 100;
  
    if (j === 1 && k !== 11) {
      return `${number}st`;
    }
    if (j === 2 && k !== 12) {
      return `${number}nd`;
    }
    if (j === 3 && k !== 13) {
      return `${number}rd`;
    }
    return `${number}th`;
  };


  return (
    <div>
      <div className='container-fluid p-0'>
        <Header />
        <div className='container-fluid p-0 contentBody PatientDashboardMain w-100'>
        {ShowLoaderPage && <LoaderSpinner />} 
        <div className="sideBarInfoDiv"> 
                       
                        <div className="titleDivRight">
                          
                          
                            <ul className="userInfoDetails">
                              <li  className="imgBox">
                                 <b> 
                                  {fullName.split(' ').map(word => word.charAt(0).toUpperCase()).join('') }  
                                </b>  
                              </li>
                            <li>
                            <h2 className="capitalizeTxt">{fullName}</h2>
                              </li>
                            <li>
                              <span style={{display:"flex", justifyContent:'center',alignItems:'center'}}>
                                <img src={Icons[0].admin_mailIcon}  />
                                <label className="singleLineEllipsis">{email}</label>
                                </span>
                              </li>
                              
                              <li>
                                <img src={Icons[0].admin_phoneIcon} />
                                <label>{phoneNumber}</label>
                              </li>

                              <li className="dateNgenderTxt">
                              <span style={{display:"flex", justifyContent:'space-between'}} className="w-100">
                                <b className={GenderTxt ? '' : 'd-none'}>
                                <img src={Icons[0].admin_userIcon} />
                                <label className="capitalizeTxt">{GenderTxt}</label>
                              </b>
                              <b className={DOBTxt ? '' : 'd-none'}>
                                <img src={Icons[0].admin_calendarIcon} />
                                <label>{moment(DOBTxt).format('MMM DD, YYYY')}{' '}({ageCal} years)</label>
                                </b>
                                </span>
                              </li>
                            </ul>
                            <div className="listOptDiv">
                            <ul className={"userMedicalInfo "
                              //  + (CheckExpiry && ' dateExpiryTxt')
                              }
                               >
                              {/* {CheckExpiry &&
                                <h3> <img src={Icons[0].errorImg} style={{width:'24px', marginRight:'5px'}} /> Health card has expired </h3>
                              } */}
                              <li> 
                                <b>{myinsuranceinfo.group_name}</b>
                                <label>Group name</label>
                              </li>
                              <li className="float-right"> 
                              <b>{myinsuranceinfo.policy_id}</b>                              
                                <label>Insurance ID</label>
                              </li> 
                              <li>
                              <b>{myinsuranceinfo.insurance_carrier}</b>
                                <label>Insurance Carrier</label>
                              </li>
                              <li>
                                <b>{WeightTxt ? WeightTxt : '0'}{' '}<span>lbs</span></b>
                                <label>Weight</label>
                              </li>
                              <li>
                                <b>{HeightTxt ? HeightTxt : '0'}{' '}<span>cm</span></b>
                                <label>Height</label>
                              </li>
                            </ul>
                             <ul className="OptionDivInfo">
                              <li className="w-100">
                                <button onClick={newappointmentLink} className={'w-100 '
                                  // +(CheckExpiry && ' dateExpiryBtn')
                                  }>
                                  <img src={Icons[0].addIcon}  />
                                  {/* Create Appointment */}
                                  Click here to start
                                  </button>
                              </li>
                              {/* Export Health Records and View Health Summary buttons hidden
                              <li className="fhirActionBtn">
                                <button
                                  onClick={handleDownloadMyFHIR}
                                  disabled={isDownloadingFHIR}
                                  style={{ background: '#024C9C', color: '#fff', border: 'none', opacity: isDownloadingFHIR ? 0.6 : 1, cursor: isDownloadingFHIR ? 'not-allowed' : 'pointer' }}
                                >
                                  {isDownloadingFHIR ? 'Exporting...' : 'Export Health Records'}
                                </button>
                              </li>
                              <li className="fhirActionBtn">
                                <button
                                  onClick={() => {
                                    setShowFhirSummary(v => !v);
                                    if (!fhirSummary) loadFHIRSummary(UserId);
                                  }}
                                  style={{ background: showFhirSummary ? '#024C9C' : '#f0f4ff', color: showFhirSummary ? '#fff' : '#024C9C', border: '1px solid #024C9C', opacity: fhirSummaryLoading ? 0.6 : 1, cursor: fhirSummaryLoading ? 'not-allowed' : 'pointer' }}
                                  disabled={fhirSummaryLoading}
                                >
                                  {fhirSummaryLoading ? 'Loading...' : (showFhirSummary ? 'Hide Health Summary' : 'View Health Summary')}
                                </button>
                              </li>
                              */}
                              {/* <li>
                                <b className="text-center">{UserHistoryNumber}</b>
                                <label>Appointments</label>
                              </li> */}
                            </ul>  
                            </div>
                        </div>  
        </div>
         
        <div className="appointmenttable ">
 
      <div className='container-fluid p-0 adminDashboardMain '>
     
      
         
     
            

              <div className="contentInnerBody">
               
                
                <div className="contentMainBox viewPatientMain">


                    <div className={"patientHistoryMain " +(showSummay ? 'd-none':'')}>
                      <div className="whiteBg innerDivRecords m-0 pb-2">
                                  <div className="titleDiv">
                                      <h2>All Appointments</h2>
                                      <ul className={"titleRightSideDiv " + (  UserHistoryData.length != 0 ? '':'d-none'  )}> 
                                        <li>   
                                            <div className="table-options">
                                              <label htmlFor="recordsPerPage">Showing</label>
                                              <select id="recordsPerPage" value={recordsPerPage} onChange={handleRecordsPerPageChange}>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                              </select> 
                                            </div>
                                          </li> 
                                      </ul>
                                    </div>
                          { UserHistoryData.length != 0 ? (<>
                              <div className="table-container">
                                  <table id="patientTable">
                                    <thead>
                                      <tr>
                                        <th>Illnesses</th>
                                        {/* <th  style={{textAlign:'center'}}>Last Measurement</th> */}
                                        <th  style={{textAlign:'center'}}>Height/Weight</th>
                                        <th  style={{textAlign:'center'}}>Consultation Date</th>
                                        <th  style={{textAlign:'center'}}>Status</th>
                                        <th  style={{textAlign:'right', paddingRight: '50px'}}>Action</th> 
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {renderTableBody()}
                                    </tbody>
                                  </table>
                                </div>
                                </>):(<>
                                  <div className="titleDiv text-center table-container d-flex justify-content-center align-items-center nodataRecords">
                                    <span className="d-grid text-center">
                                    <h2 className="text-center"> No table record </h2>
                                      <hr></hr>
                                      
                                      <button onClick={newappointmentLink} className={"createNewAppointmentBtn "
                                        // +(CheckExpiry && ' dateExpiryBtn')
                                        }> 
                                        <img src={Icons[0].addIcon} style={{marginRight: "5px"}}  />
                                        Click here to start
                                        </button>
                                      
                                      </span>  
                                      </div>
                                  </>)
    }
                      </div> 
                            
                        <div className={"paginationMain " +(showSummay ? 'd-none':'') + (  UserHistoryData.length != 0 ? '':'d-none'  )}>
                                {renderPagination()}
                                <span className="totalPageDiv">Total Pages: {totalPages}</span>
                        </div>
                    </div>

                     <div className={"patientSummaryMain " +(!showSummay ? 'd-none':'')}>
                 
    <div className="innerDivRecords " >
 
		<nav>
			<div className="nav nav-tabs mb-0" id="nav-tab" role="tablist">
				<button className={`nav-link ${activeTab === 0 ? 'active' : ''}`}
            onClick={() => handleTabClick(0)} id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Summary</button>
				{/* <button className={`nav-link ${activeTab === 1 ? 'active' : ''}`}
            onClick={() => handleTabClick(1)} id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Plan of Care</button> */}
				<button className={`nav-link ${activeTab === 2 ? 'active' : ''}`}
            onClick={() => handleShowChat(2)} id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">Presenting Symptoms</button>
			  <button className={`nav-link ${activeTab === 3 ? 'active' : ''}`}
            onClick={() => handleShowChat(3)} id="nav-reportData-tab" data-bs-toggle="tab" data-bs-target="#nav-reportData" type="button" role="tab" aria-controls="nav-reportData" aria-selected="false">Reports</button>
        {finalConsultantNote && isFinalNoteSubmitted && selectedZoomMeet?.meeting_status === 'completed' && (
          <button className={`nav-link ${activeTab === 5 ? 'active' : ''}`}
            onClick={() => handleTabClick(5)} id="nav-finalnote-tab" data-bs-toggle="tab" data-bs-target="#nav-finalnote" type="button" role="tab" aria-controls="nav-finalnote" aria-selected="false">Final Consultant Note</button>
        )}
			</div>
      <button className="backBtn" onClick={showSummay ? (handleHideSummary) :(handleShowDashboard)}                        
                            ><img src={Icons[0].admin_backBtn} />Back</button>
		</nav>
		<div className="whiteBg tab-content p-3 bg-white" id="nav-tabContent" >
			<div className={`tab-pane fade ${activeTab === 0 ? 'active show' : ''}`} id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
        <div className="despInfoDiv  position-relative  d-flex" style={{height: '70px'}}>
          <h2>Summary</h2>
          <div  className="headDespInfoDiv position-absolute top-0 end-0 ">
            {/* <ul className="infoDivPatientList" >
            <li>
              <label>Consultation Date</label>
              <b> {formatConsultationDate(RecordData?.created_on, RecordData?.created_at)}</b>
            </li>
            <li>
              <label>Illnesses</label>
              <b>{RecordData.illness}</b>
            </li>
          </ul> */}
          <ul className="optionUpdateList" style={{width:'auto'}}>
        
        
      
              <li className={selectedItem ? '' : 'd-none'}>
                <label>Patient Status</label>
                    <button className={"selectedItemBtn color" +(selectedItem)} >
                        {selectedItem}
                    </button>
                </li>  
                {selectedZoomMeet?.meeting_status  !== 'deactive' && (
                <>
                <li className={"text-left "+(selectedZoomMeet && Object.keys(selectedZoomMeet).length > 0 ? '' :'d-none')}>
                <label>Patient Meeting</label>    
                {(!selectedZoomMeet.meeting_status || selectedZoomMeet.meeting_status === 'active') ? (
                            <button className="blueBtnStyle"
                            onClick={selectedItem?.toLowerCase() === "completed" ? null : toggleDivZoomMeet} 
                            disabled={selectedItem?.toLowerCase() === "completed"}
                            >
                              Meeting Details 
                            </button>
                          ) : (
                            <button className="blueBtnStyle" disabled>
                              Meeting Ended
                            </button>
                          )}
                          
               
                      {/* <button className="blueBtnStyle" onClick={toggleDivZoomMeet}>
                        Meeting Details 
                      </button> */}

          {openDiv === 'ZoomMeet' && (
             <div  className="patientStatusBox ZoomMeetMain"  style={{zIndex: '11'}}> 
              {selectedZoomMeet && Object.keys(selectedZoomMeet).length > 0 ? (
                    <>
                    <div className="p-2">
                     <h2 className="mb-2">Meeting Details</h2>
                     <div className="meetingDetailsTxt">
                         <label className="labelTxt">Meeting ID</label>
                         <b>{selectedZoomMeet.meeting_id}</b>                      
                      </div> 
                      <div className="meetingDetailsTxt">
                         <label className="labelTxt">Meeting Title</label>
                         <b>{selectedZoomMeet.topic}</b>                      
                      </div> 
                      
                      <div className="meetingDetailsTxt">
                         <label className="labelTxt">Date Time</label>
                         <b>{moment.unix(selectedZoomMeet.start_ts).format("MMM DD, YYYY - h:mm A")}</b>                      
                      </div>
                   
                      <div className="meetingDetailsTxt">                    
                        <button onClick={handleButtonClickZoomMeet}>Join Meeting</button>                     
                      </div> 
                      </div>
                      
                    </> ):('')}
                    </div>
                  )}
                   
                </li>
                </> )}
                {(selectedZoomMeet?.meeting_status === 'deactive' || followupZoomMeet || checkFollowupMeet) && (<>
                <li style={{width:"130px"}}
        >
            <label className={followupZoomMeet}>Follow-up</label> 
  <button
  className={"selectedItemBtn " + (followupZoomMeet ? (followupMeetingDone ? 'greenBtnStyle' : 'blueBtnStyle newBlueBtn') : 'newClickBtn')}
  onClick={toggleDivFollowup}
  style={{ width: followupZoomMeet ? "120px" : "110px", padding: "5px", ...(followupMeetingDone ? { background: '#28a745', borderColor: '#28a745' } : {}) }}
>
  {
    followupZoomMeet
    ? (followupMeetingDone ? "Completed" : "Meeting Active")
    : checkFollowupMeet
    ? "Request Sent"
    : "Add Followup"}
</button>

      {openDiv === 'Followup' && (
 <div className="patientStatusBox datePickerDiv followupSetMain  ZoomMeetMain" style={{ border: '1px solid #ccc', marginTop: '10px', padding: '10px', zIndex: '11'}}>
         
         {selectedItemFollowup && Object.keys(selectedItemFollowup).length > 0 ? (<>
           
          <h2 style={{fontSize:'16px'}}  className="mb-2">Follow up Details </h2>
                  
                                     
                      {followupZoomMeet ? (
                            <>
                              <div className="meetingDetailsTxt">
                         <label className="labelTxt">Meeting ID</label>
                         <b>{selectedItemFollowup.zoom_meeting.meeting_id}</b>                      
                      </div> 
                      <div className="meetingDetailsTxt">
                         <label className="labelTxt">Meeting Title</label>
                         <b>{selectedItemFollowup.zoom_meeting.topic}</b>                      
                      </div> 
                      
                      <div className="meetingDetailsTxt">
                         <label className="labelTxt">Date Time</label>
                         <b>{moment.unix(selectedItemFollowup.zoom_meeting.start_ts).format("MMM DD, YYYY - h:mm A")}</b>                      
                      </div>
                      <div className="meetingDetailsTxt">
                              {followupMeetingDone ? (
                                <span style={{ color: '#28a745', fontWeight: '600', fontSize: '13px' }}>Meeting Completed</span>
                              ) : (
                                <button onClick={handleButtonClickFollowZoomMeet}>Join Meeting</button>
                              )}
                              </div>
                              
                            </>
                          ) : (
                            <>
                              <div className="meetingDetailsTxt">
                         <label className="labelTxt">Title</label>
                         <b>{selectedItemFollowup.title}</b>                      
                      </div>                          
                       
                         <div className="meetingDetailsTxt align-items-start"> 
                          <label className="labelTxt">Description: </label>
                          <b className="twoLineEllipsis" title={selectedItemFollowup.description} >{selectedItemFollowup.description}</b> 
                          </div>
                            <div className="meetingDetailsTxt">  
                              <button className="newBtn cancelBtn" disabled={true}>Request in Progress</button>  
                              </div>                  
                            </>
                          )}  
                    
        
                      

         </>):(<>
          <form>
            
            <div>
              <h3 style={{fontSize:'16px'}}  className="mb-2">Follow-Up: Choose any one</h3>
              <ul className="followupOptList">          
              {options.map((option, index) => (
                  <li
                    key={index}
                    className={activeOption === option ? 'active' : ''} // Apply "active" class to the selected item
                    onClick={() => handleOptionClick(option)} // Handle click event
                  >
                    {option}
                  </li>
                ))}
              </ul>
            </div>
            <h3 style={{fontSize:'16px'}} className="mb-0">Follow-up Description</h3>
           <div className="mt3 inputDiv fillDetailsForm newFillDetailForm d-flex">
                <textarea  
                    className="textareaFollowup"  
                    value={transcripts.medicalcondition}
                    onChange={handleTextChangeMedicalCondition} 
                    placeholder={activeMic === 'medicalcondition' ? 'Mic On ' : ""} > 
                </textarea>
            <span className="attachmentSpan">
              <a onClick={() => handleMicClick('medicalcondition')}  
              disabled={isConnecting || activeMic === 'connecting'} 
              className={ (activeMic === 'medicalcondition' ? 'deactiveBtnClass' : 'activeBtnClass')}> 
                  <img src={Icons[0].micIcon}  className= "logoImg "   alt="" />
              </a> 
            </span> 
            </div> 

            <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
              <button className="newBtn cancelBtn" onClick={handleCancelFollowup}>
                Cancel
              </button> 
              <button 
                     onClick={handleFollowUpSubmit}
                      className="newBtn"
                      type="submit"
                      disabled={loading}
                      style={{
                        cursor: loading ? 'not-allowed' : 'pointer',
                      }}
                    >
                      {loading ? 'Saving...' : 'Save'}
             </button>
            </div>
         
        </form>
         </>)
 
         }
       
        </div>
      
                  )}


                </li>
                </>)}
        </ul>
        </div>

        </div>
        <div className="innerDivBox"> 
        {FollowupData?.length > 0 ? (
         [...FollowupData]
         .sort((a, b) => new Date(b.created_on) - new Date(a.created_on)) // Sort by `created_on` in descending order
         .map((item, index) => 
            item.followup_summary ? ( // Check if followup_summary exists
              <div key={index}>
                <div className="despInfoDiv">
                <div className="headDespInfoDiv">
                  <ul className="infoDivPatientList">
                    <li>
                      <label> {`${getOrdinalLabel(FollowupData.length - index + 1)} Consultation`}</label>
                      <b>{formatConsultationDate(item.created_on, item.created_at)}</b>
                    </li>
                    <li>
                      <label>Follow up</label>
                      <b>{item.title}</b>
                    </li>
                    {/* {
                      calculateDuration(item.zoom_meeting.start_ts, item.zoom_meeting.end_ts)
                        ? <li>
                          <label>Duration:</label>
                          <b>{calculateDuration(item.zoom_meeting.start_ts, item.zoom_meeting.end_ts)}</b>
                          </li>
                        : null
                    } */}

{ calculateDuration(item.zoom_meeting.start_ts, item.zoom_meeting.end_ts) ?
                                (<>
                                  <li  >
                                    <label>Physician</label>
                                    <b className="flexDiv"><img src={Icons[0].locationIcon} style={{width:'20px'}}/>Office</b>
                                 </li>
                                 <li  >
                                    <label>Patient </label>                                    
                                    <b className="flexDiv"><img src={Icons[0].locationIcon} style={{width:'20px'}}/>Home</b>
                                 </li>
                                 <li  >
                                    <label>Communication</label>
                                    <b>Audio & Video</b>
                                 </li>
                                  <li >
                                  <label>Duration</label>{" "}
                                  <b>{calculateDuration(selectedZoomMeet.start_ts, selectedZoomMeet.end_ts)}  </b>
                                  </li>
                                  <li >
                                  <label>Verbal consent </label>{" "}
                                  <b>Obtained</b>
                                  </li>
                                  
                                
                                </>
                                ):null }

                    {/* <li>
                        <label>Duration:</label>{" "}
                        <b>{calculateDuration(item.zoom_meeting.start_ts, item.zoom_meeting.end_ts)}</b>
                      </li> */}
                      {/* <li>
                         <label>Location</label>
                          <b>Home</b>
                      </li> */}
                  </ul>
                </div>
              </div>
              <pre className="innerDivBoxPC h-auto">{item.followup_summary}</pre>
              <hr className="my-4"></hr>
              </div>
            ) : null // If followup_summary is null, render nothing
          )
        ) : null}
				   <div className="despInfoDiv">
      <div className="headDespInfoDiv">
            <ul className="infoDivPatientList">
              <li>
                <label>Consultation Date</label>
                <b> {formatConsultationDate(RecordData?.created_on, RecordData?.created_at)}</b>
              </li>
              <li>
                <label>Illnesses</label>
                <b>{RecordData.illness}</b>
              </li>
              {/* {selectedZoomMeet.length > 0 ?
                      (<>
                        <li>
                        <label>Duration:</label>{" "}
                        <b>{calculateDuration(selectedZoomMeet.start_ts, selectedZoomMeet.end_ts)}  </b>
                        </li>
                        <li>
                            <label>Location</label>
                            <b>Home</b>
                        </li>
                      </>
                      ): null }  */}

{selectedZoomMeet.length > 0 ?
                                (<>
                                  <li  >
                                    <label>Physician</label>
                                    <b className="flexDiv"><img src={Icons[0].locationIcon} style={{width:'20px'}}/>Office</b>
                                 </li>
                                 <li  >
                                    <label>Patient </label>                                    
                                    <b className="flexDiv"><img src={Icons[0].locationIcon} style={{width:'20px'}}/>Home</b>
                                 </li>
                                 <li  >
                                    <label>Communication</label>
                                    <b>Audio & Video</b>
                                 </li>
                                  <li >
                                  <label>Duration</label>{" "}
                                  <b>{calculateDuration(selectedZoomMeet.start_ts, selectedZoomMeet.end_ts)}  </b>
                                  </li>

                                  
                                  <li >
                                  <label>Verbal consent </label>{" "}
                                  <b>Obtained</b>
                                  </li>
                                
                                </>
                                ):null }

                
            </ul>
            </div>
          </div>
          {EmergencyQuest ? (<><p className="innerDivBox urgentTxt"><img src={Icons[0].admin_icon911} /> Urgent: Patient has called for emergency assistance.</p></>) :
          !isFinalNoteSubmitted ? (
            <p className="innerDivBox" style={{fontStyle:'italic', color:'#888', textAlign:'center'}}>
              Your clinical summary will be available once your care team has completed the consultation and finalized your report.
            </p>
          ) :
          RecordData.chatbot_summary ? <div className="innerDivBoxPC h-auto ">{renderAISummary(RecordData.chatbot_summary)}</div> :  <p className="innerDivBox"> - </p> }
          </div>
          
			</div>
			<div className={`tab-pane fade ${activeTab === 1 ? 'active show' : ''}`} id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
      <div className="d-flex gap-4">
               <div className="despInfoDiv PlanCareTab w-50">
          <h2>Plan of Care  
          {!EmergencyQuest ? ( <a onClick={handleInputMainPoint} style={{marginLeft:'10px', cursor:'pointer'}}  className={ImageHide ? "editBtnNew " : "editBtnNew "}> Edit <img src={!showMainPoint ? Icons[0].editIcon : Icons[0].editRed } /></a>) :  ('')}
          </h2>
        
         
          {!showMainPoint ? (
                  <>     
                   {EmergencyQuest ? <p className="innerDivBoxPC urgentTxt"><img src={Icons[0].admin_icon911} /> Urgent: Patient has called for emergency assistance.</p> : PlanOnCareData ? <pre className="innerDivBoxPC">{PlanOnCareData}</pre> : 'No Plan On Care' }  
                 </>
              ) :(
                <div className='textareaSummary innerDivBox w-100'>
                  <textarea value={PlanOnCareData} onChange={handleInputChangeMPoint} style={{    height: '80%', width:' 100%'}} /> 
                  <hr></hr>
                 <div className='editSaveOpt' >
                    {ShowLoader ? (<>
                      <button  > Loading
                      <div className="spinner-border text-light" role="status">
                       <span className="visually-hidden">Loading...</span>
                    </div> 
                    </button>
                    </>):(<>
                      <button onClick={handleSaveClickMPoint}>  
                    Save Changes
                    </button>
                    </>)

                    }
                    
                    <button onClick={handleCancelClickMPoint}>Cancel</button>
                  </div>
                </div> 

              )}
               </div>
                <div className="despInfoDiv PlanCareTab w-50  ">
          <h2>Conditional Diagnosis
          {!EmergencyQuest ? ( <a onClick={handleInputMainPointCD} style={{marginLeft:'10px', cursor:'pointer'}}  className={ImageHide ? "editBtnNew " : "editBtnNew "}> Edit <img src={!showMainPointCD ? Icons[0].editIcon : Icons[0].editRed } /></a>) :  ('')}
          </h2>
          {!showMainPointCD ? (
                  <>     
                   {EmergencyQuest ? <p className="innerDivBoxPC urgentTxt"><img src={Icons[0].admin_icon911} /> Urgent: Patient has called for emergency assistance.</p> : 
                   ConditionalDiagnosis ? <pre className="innerDivBoxPC ">{ConditionalDiagnosis}</pre> : 'No Conditional Diagnosis' }  
                 </>
              ) :(
                <div className='textareaSummary innerDivBox w-100'>
                  <textarea value={ConditionalDiagnosis} onChange={handleInputChangeMPointCD} style={{    height: '80%', width:' 100%'}} /> 
                  <hr></hr>
                 <div className='editSaveOpt' >
                    {ShowLoader ? (<>
                      <button  > Loading
                      <div className="spinner-border text-light" role="status">
                       <span className="visually-hidden">Loading...</span>
                    </div> 
                    </button>
                    </>):(<>
                      <button onClick={handleSaveClickMPointCD}>  
                    Save Changes
                    </button>
                    </>)

                    }
                    
                    <button onClick={handleCancelClickMPointCD}>Cancel</button>
                  </div>
                </div> 

              )}
               </div> 

      </div>
      </div>
			<div className={`tab-pane fade ${activeTab === 2 ? 'active show' : ''}`} id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
      <div className="despInfoDiv">
          <h2>Presenting Symptoms</h2>
          </div>
        <div className="chatbotConversation  pb-0">
      <div className="messageListBox mb-0">
      {answerLoader ? ( 
                    <>
                    <div className= "quesListDiv " >
                        <div className={"chatbot aiQuest "}>
                            <span className="imgBox">
                              <img src={Icons[0].chatbot} alt="Chatbot" />
                            </span>
                            <span> 
                                <div className="showLoaderDot">
                                  <span></span>
                                  <span></span>
                                  <span></span>
                                </div> 
                            </span>
                          </div>
                    </div>
                    </>):(<>
                    
                      <div className="chatbot">
                <span className="imgBox">
                  <img src={Icons[0].chatbot} alt="Chatbot" />
                </span>
                <span>
                  <b className="AI_dateTime">
                    AI 
                  </b> 
                      <label className="quesTxt">Hi, How may I help you today? You may select or type a symptom you’re facing currently.</label>
                      <div className="questOpt">
                        <b>Please select any</b>
                        <ul className={!selectedIllness ? 'illnessesListOpt' : 'illnessesListOpt selected'}>
                          {illnessesList?.map((item, index) => (
                            <li
                              key={index}
                              className={selectedIllness === item ? 'active' : 'disabled'} 
                              style={{ pointerEvents: selectedIllness && selectedIllness !== item ? 'none' : 'auto' }}
                            >
                              <b>{item}</b>
                            </li>
                          ))}
                        </ul>
                      </div>
                     
                </span>
              </div>

           {ChatHistory.length > 0 && (
                <div className="quesListDiv">
                  {ChatHistory.map((q, index) => (
                    <div key={index}>
                      <div className="chatbot aiQuest">
                        <span className="imgBox">
                          <img src={Icons[0].chatbot} alt="Chatbot" />
                        </span>
                        <span> 
                              <b className="AI_dateTime">
                                AI 
                              </b>
                              <label className="quesTxt">{q.question}</label>
                             
                        </span>
                      </div>
                      {q.answer && (
                        <div className="chatbot userReply">
                          <span className="imgBox">
                            <b>{fullName?.split(' ').map(word => word.charAt(0).toUpperCase()).join('')}</b>
                          
                          </span>
                          <span>
                            <b className="AI_dateTime">
                              YOU 
                            </b>
                            <label className="quesTxt">{q.answer}</label>
                          </span>
                        </div>
                      )} 
                    </div>
                  ))}
                </div>
              )} 
                    
                    </>)}
              

            </div> 
     </div>
		 
			</div>
      <div className={`tab-pane fade ${activeTab === 3 ? 'active show' : ''}`} id="nav-reportData" role="tabpanel" aria-labelledby="nav-reportData-tab">
      <div className="despInfoDiv">
          <h2>Reports </h2>
          </div>
          <div className="innerDivBoxPC"> 
             {/* {reportData ? (
            <ol className="reportListOptLink">
               {Object.keys(reportData).map((category) => (
                  <React.Fragment key={category}>
            
                     
                    {reportData[category].file_urls.map((url, index) => (
                      url ? (
                        <li key={index}>
                            <a href={url} target="_blank" rel="noopener noreferrer" style={{ textTransform: "capitalize", textDecoration: "none" }}>
                              {category.replace('_', ' ')} {category === 'upload_report' ? `File ${index + 1}` : ''} <img src={Icons[0].pdf_Icon} alt="PDF Icon" style={{ width: "24px" }} />
                            </a>
                        </li>
                      ) : ( <p style={{textAlign:'center'}}>No reports found</p> )
                    ))}
                  </React.Fragment>
                ))}
            </ol> ) : (
              <ol className="reportListOptLink">
                <p style={{textAlign:'center'}}>No reports found</p>
              </ol>
            )}   */}

{/* {reportData ? (
    <ol className="reportListOptLink">
        {Object.keys(reportData).map((category) => (
            <React.Fragment key={category}> 
                {reportData[category].file_urls.map((url, index) => (
                    url ? (
                        <li key={index}>
                            <b style={{ textTransform: "capitalize", textDecoration: "none" }}>{category.replace('_', ' ')}</b>
                           <span className="pdfButtonModal">
                            <a href={url} target="_blank" className="pdfButton d-none" rel="noopener noreferrer" style={{ textTransform: "capitalize", textDecoration: "none" }}>
                              
                                Download
                              
                                <img src={Icons[0].downloadPDF} alt="PDF Icon" style={{ width: "24px", marginLeft: "10px" }} />
                            </a>
                             <button className="pdfButton" onClick={() => openModal(url)}>
                               View <img src={Icons[0].viewPDF} alt="PDF Icon" style={{ width: "24px", marginLeft: "10px" }} />
                              </button>
                              </span> 
                            {reportData[category].texts[index] && (
                                <p style={{ margin: "5px 0", textTransform: "capitalize" }}>
                                    {reportData[category].texts[index]}
                                </p>
                            )} 
                        </li>
                    ) : null
                ))}
 
                {reportData[category].file_urls.length === 0 && reportData[category].texts.length === 0 && (
                    <p style={{ textAlign: 'center' }}>No reports found</p>
                )}
            </React.Fragment>
        ))}
    </ol>
) : (
    <ol className="reportListOptLink">
        <p style={{ textAlign: 'center' }}>No reports found</p>
    </ol>
)} */}

<ol className="reportListOptLink">
  {sortedGroupedDocuments.length > 0 ? (
    sortedGroupedDocuments
      .filter(({ documents }) => documents && documents.length > 0) // Filter out empty or null documents
      .map(({ doc_type, documents, Name  }) => (
        <li key={doc_type}>
       
          {documents.map((doc, index) => (
            <div key={doc.doc_id} style={{ marginBottom: "0px" }}>
                 <b style={{ textTransform: "capitalize", textDecoration: "none" }} className={ doc_type === "other_report"  && index !== 0 && 'd-none'}>
                 {Name} 
                 {/* {doc_type.replace('_', ' ')} */}
                 </b>
              {/* Document URL with conditional button */}
              {doc.doc_url && (
                <span
                  className={
                    "pdfButtonModal" + (doc_type === "other_report" ? " d-none" : "")
                  }
                >
                  <button
                    className="pdfButton pdfViewBtn"
                    onClick={() => openModal(doc?.doc_url)}
                  >
                    View{" "}
                    <img
                      src={Icons[0].viewPDF}
                      alt="PDF Icon"
                      style={{ width: "24px", marginLeft: "10px" }}
                    />
                  </button>
                </span>
              )}

              {/* Document Text */}
              <p>{doc.doc_text}</p>

              <div className={"d-flex justify-content-between align-items-center "  +(doc.doc_summary.length === 4 && doc.doc_summary === "None" ? 'd-none' : null) }>
                <h3
                  style={{
                    fontSize: "16px",
                    marginTop: "14px",
                    fontWeight: "600",
                  }}
                  className="my-0"
                >
                 {
                    doc_type === "other_report" ? (
                      <>
                        {index + 1}. Other Report Summary
                      </>
                    ) : doc_type === "pcp" || doc_type === "pharmacy" ? (
                        null
                    ) : doc.doc_summary ? (
                      <>Report Summary</>
                    ) : null
                  }
                </h3>

                {/* Document URL Button (specific condition) */}
                {doc.doc_url && (
                  <span
                    className={
                      "pdfButtonModal" +
                      (doc_type !== "other_report" ? " d-none" : "")
                    }
                  >
                    <button
                      className="pdfButton pdfViewBtn"
                      onClick={() => openModal(doc?.doc_url)}
                    >
                      View{" "}
                      <img
                        src={Icons[0].viewPDF}
                        alt="PDF Icon"
                        style={{ width: "24px", marginLeft: "10px" }}
                      />
                    </button>
                  </span>
                )}
              </div>

              {/* Document Summary */}
              {
                doc.doc_summary ? (
                  <pre
                    style={{ margin: "5px 0", textTransform: "capitalize" }}
                    className={doc.doc_summary.length === 4 && doc.doc_summary === "None" ? 'd-none' : null}
                  >
                    {doc.doc_summary}
                  </pre>
                ) : null
              }

              {/* Conditional Divider */}
              {doc.doc_url && (
                <hr className={doc_type !== "other_report" ? " d-none" : ""} />
              )}
            </div>
          ))}
        </li>
      ))
  ) : (
    <p style={{ textAlign: "center" }}>No reports found</p>
  )}
</ol>


          </div>

          </div>

      {/* Tab 5: Final Consultant Note (read-only for patient) */}
      <div className={`tab-pane fade ${activeTab === 5 ? 'active show' : ''}`} id="nav-finalnote" role="tabpanel" aria-labelledby="nav-finalnote-tab">
        <div className="despInfoDiv position-relative d-flex" style={{ height: '50px', alignItems: 'center' }}>
          <h2 style={{ margin: 0 }}>Final Consultant Note</h2>
          {finalConsultantNote && (
            <div className="position-absolute top-0 end-0" style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
              <a onClick={!isGeneratingPdf ? downloadFinalNotePdf : undefined} style={{ cursor: isGeneratingPdf ? 'not-allowed' : 'pointer', width: 'auto', padding: '0 10px', opacity: isGeneratingPdf ? 0.6 : 1 }} className="editBtnNewSummary">
                {isGeneratingPdf ? 'Generating...' : 'Download PDF'}
              </a>
            </div>
          )}
        </div>

        {/* Report version history dropdown — mirrors admin view */}
        {patientReportHistory.length > 1 && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: '8px 0 12px 0', padding: '8px 14px', background: '#f0f4f8', borderRadius: '6px', border: '1px solid #d0d7e2', flexWrap: 'wrap' }}>
            <span style={{ fontSize: '12px', color: '#4a6fa5', fontWeight: '700', whiteSpace: 'nowrap' }}>Report Version:</span>
            <select
              value={selectedPatientReportVersion || ''}
              onChange={(e) => handleViewPatientReportVersion(e.target.value || null)}
              style={{ flex: 1, minWidth: '220px', maxWidth: '420px', fontSize: '12px', padding: '5px 8px', borderRadius: '4px', border: '1px solid #b0c0d8', background: '#fff', cursor: 'pointer' }}
            >
              <option value="">Latest Submitted</option>
              {patientReportHistory.map(h => (
                <option key={h.version} value={h.version}>
                  V{h.version} — {h.report_type === 'initial' ? 'Initial Report' : `Followup: ${h.followup_topic || 'Consultation'}`}
                  {(h.submitted_at || h.final_consultant_generated_at) ? ` · ${new Date(h.submitted_at || h.final_consultant_generated_at).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })}` : ''}
                </option>
              ))}
            </select>
            <span style={{ fontSize: '11px', color: '#888' }}>({patientReportHistory.length} versions)</span>
            {selectedPatientReportVersion && (
              <a onClick={() => handleViewPatientReportVersion(null)} style={{ cursor: 'pointer', fontSize: '12px', color: '#024C9C', fontWeight: '600', textDecoration: 'underline', whiteSpace: 'nowrap', marginLeft: 'auto' }}>
                Back to Latest
              </a>
            )}
          </div>
        )}

        {/* Attached Assessment & Plan files */}
        {selectedFinalNoteFiles.length > 0 && (
          <div style={{ padding: '8px 15px 10px' }}>
            <span style={{ fontSize: '12px', color: '#666', fontWeight: '600', marginBottom: '6px', display: 'block' }}>Attached Documents:</span>
            {assessmentFileCategories.map((cat) => {
              const catFiles = cat.files.filter((f) => selectedFinalNoteFiles.some((sf) => sf.id === f.id));
              if (catFiles.length === 0) return null;
              return (
                <div key={cat.category} style={{ marginBottom: '8px' }}>
                  <div style={{ fontSize: '11px', fontWeight: '700', color: '#024C9C', padding: '4px 0', borderBottom: '1px solid #e3eaf5', marginBottom: '4px' }}>{cat.category}</div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px' }}>
                    {catFiles.map((file) => (
                      <div key={file.id} style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        background: '#f8fafd', padding: '5px 10px',
                        borderRadius: '5px', border: '1px solid #e2e8f0',
                      }}>
                        <span style={{ fontSize: '12px', fontWeight: '500', color: '#013c7d', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{file.fileName}</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0, marginLeft: '8px' }}>
                          <a href={file.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#024C9C', fontWeight: '600', textDecoration: 'none', cursor: 'pointer' }}>View</a>
                          <a href={file.url} download={file.fileName + '.pdf'} style={{ fontSize: '11px', color: '#024C9C', fontWeight: '600', textDecoration: 'none', cursor: 'pointer' }}>Download</a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div className="innerDivBoxPC">
          {(finalConsultantNote || finalConsultantHPI) ? (
            <div>
              <div ref={finalNoteContentRef}>
                {finalConsultantHPI ? (
                  <>
                    <div style={{ marginBottom: '16px' }}>
                      <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>History of Present Illness (HPI)</h3>
                      <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(finalConsultantHPI)}</div>
                    </div>
                    {finalConsultantPMH && (
                      <div style={{ marginBottom: '16px' }}>
                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Past Medical History (PMH)</h3>
                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(finalConsultantPMH)}</div>
                      </div>
                    )}
                    {finalConsultantMedications && (
                      <div style={{ marginBottom: '16px' }}>
                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Medications</h3>
                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(finalConsultantMedications)}</div>
                      </div>
                    )}
                    {finalConsultantAllergies && (
                      <div style={{ marginBottom: '16px' }}>
                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Allergies</h3>
                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(finalConsultantAllergies)}</div>
                      </div>
                    )}
                    {finalConsultantSocialHistory && (
                      <div style={{ marginBottom: '16px' }}>
                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Social History</h3>
                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(finalConsultantSocialHistory)}</div>
                      </div>
                    )}
                    {finalConsultantROS && (
                      <div style={{ marginBottom: '16px' }}>
                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Review of Systems</h3>
                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(finalConsultantROS)}</div>
                      </div>
                    )}
                    {finalConsultantNote && (
                      <div style={{ marginBottom: '16px' }}>
                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Assessment & Differential Diagnosis</h3>
                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(finalConsultantNote)}</div>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {finalConsultantNote && (
                      <div style={{ marginBottom: '16px' }}>
                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Assessment & Differential Diagnosis</h3>
                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(finalConsultantNote)}</div>
                      </div>
                    )}
                  </>
                )}
                {finalConsultantPlan && (() => {
                  const planLines = finalConsultantPlan.split('\n');
                  let currentSection = '';
                  let investigationLines = [];
                  let recommendationLines = [];
                  let otherLines = [];

                  planLines.forEach(line => {
                    const trimmed = line.trim();
                    if (/^INVESTIGATIONS\s*:/i.test(trimmed) || /^\d+[\.\)]\s*INVESTIGATIONS\s*:/i.test(trimmed)) { currentSection = 'investigation'; return; }
                    if (/^THERAPIES\s*:/i.test(trimmed) || /^\d+[\.\)]\s*THERAPIES\s*:/i.test(trimmed)) { currentSection = 'recommendation'; return; }
                    if (/^RECOMMENDATIONS\s*:/i.test(trimmed) || /^\d+[\.\)]\s*RECOMMENDATIONS\s*:/i.test(trimmed)) { currentSection = 'recommendation'; return; }
                    if (!trimmed) return;
                    if (currentSection === 'investigation') investigationLines.push(line);
                    else if (currentSection === 'recommendation') recommendationLines.push(line);
                    else otherLines.push(line);
                  });

                  return (
                    <div style={{ marginBottom: '16px' }}>
                      <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Plan of Care</h3>
                      {otherLines.length > 0 && (
                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(otherLines.join('\n'))}</div>
                      )}
                      {(investigationLines.length > 0 || doctorRecommendations.length > 0) && (
                        <div style={{ marginBottom: '10px' }}>
                          <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary('INVESTIGATIONS:\n' + investigationLines.concat(doctorRecommendations.map(r => '• ' + r)).join('\n'))}</div>
                        </div>
                      )}
                      {recommendationLines.length > 0 && (
                        <div style={{ marginBottom: '10px' }}>
                          <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary('RECOMMENDATIONS:\n' + recommendationLines.join('\n'))}</div>
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '40px 20px', color: '#888' }}>
              <p style={{ fontSize: '15px' }}>Final Consultant Note has not been generated yet.</p>
            </div>
          )}
        </div>
      </div>

		</div>
	</div>
                    </div>
                </div>

              </div>
                 
             
      
      </div>
    
        </div>
         
         
        </div> 
      </div>


       {/* Modal Popup for Viewing Documents */}
       <Modal
       className='viewDocModal'
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Document Viewer"
       
      >
        <button
          onClick={closeModal}
          style={{
            float: 'right',
            cursor: 'pointer',
            background: 'red',
            color: 'white',
            border: 'none',
            padding: '4px 10px',
            borderRadius: '0px',
            marginBottom: '-9px',
          }}
        >
          Close
        </button>
        <div style={{ display: "flex", flexDirection: "column", height: "100%", clear:'both' }}>
        {/* Ensure selectedDocument exists before rendering */}
        {selectedDocument ? (
          <>
            <h3>{selectedDocument.name}</h3>
            <embed src={selectedDocument} width="100%" height="100%" type="application/pdf"  className="innerContainer" />
            {/* Render PDF or Image based on file type */} 
          </>
        ) : (
          <p>Loading document...</p> // Fallback content if document is not available
        )}
        </div>
      </Modal>

      {/* ─── Health Summary Full-Screen Modal ─── */}
      {showFhirSummary && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
          <div style={{ background: '#fff', borderRadius: '12px', width: '100%', maxWidth: '860px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}>

            {/* Header */}
            <div style={{ background: '#024C9C', borderRadius: '12px 12px 0 0', padding: '18px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div>
                <h2 style={{ margin: 0, color: '#fff', fontSize: '18px', fontWeight: '700' }}>My Health Summary</h2>
                <p style={{ margin: '2px 0 0', color: 'rgba(255,255,255,0.75)', fontSize: '12px' }}>FHIR R4 Health Records</p>
              </div>
              <button onClick={() => setShowFhirSummary(false)} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', fontSize: '20px', width: '34px', height: '34px', borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1 }}>×</button>
            </div>

            {/* Body */}
            <div style={{ overflowY: 'auto', padding: '24px', flex: 1 }}>
              {fhirSummaryLoading ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                  <div style={{ fontSize: '32px', marginBottom: '12px' }}>⏳</div>
                  <p style={{ margin: 0 }}>Loading your health data...</p>
                </div>
              ) : !fhirSummary || (fhirSummary.conditions.length === 0 && fhirSummary.allergies.length === 0 && fhirSummary.medications.length === 0) ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
                  <div style={{ fontSize: '40px', marginBottom: '12px' }}>📋</div>
                  <p style={{ margin: 0, fontSize: '15px' }}>No health summary data available yet.</p>
                  <p style={{ margin: '6px 0 0', fontSize: '13px' }}>Complete an appointment to see your health records here.</p>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

                  {/* Conditions Section */}
                  {fhirSummary.conditions.length > 0 && (
                    <div style={{ border: '1px solid #dce8ff', borderRadius: '10px', overflow: 'hidden' }}>
                      <div style={{ background: '#024C9C', padding: '12px 18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ fontSize: '18px' }}>🩺</span>
                        <span style={{ color: '#fff', fontWeight: '700', fontSize: '14px' }}>Conditions</span>
                        <span style={{ background: 'rgba(255,255,255,0.25)', color: '#fff', borderRadius: '12px', padding: '2px 10px', fontSize: '12px', marginLeft: 'auto' }}>{fhirSummary.conditions.length}</span>
                      </div>
                      <div style={{ padding: '14px 18px', display: 'flex', flexWrap: 'wrap', gap: '8px', background: '#f4f8ff' }}>
                        {fhirSummary.conditions.map((c, i) => (
                          <span key={i} style={{ background: '#e8f0fe', color: '#1a3c6e', border: '1px solid #c5d8ff', borderRadius: '20px', padding: '6px 14px', fontSize: '13px', fontWeight: '500' }}>
                            {c._label}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Allergies Section */}
                  {fhirSummary.allergies.length > 0 && (
                    <div style={{ border: '1px solid #ffdad6', borderRadius: '10px', overflow: 'hidden' }}>
                      <div style={{ background: '#c0392b', padding: '12px 18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ fontSize: '18px' }}>⚠️</span>
                        <span style={{ color: '#fff', fontWeight: '700', fontSize: '14px' }}>Allergies</span>
                        <span style={{ background: 'rgba(255,255,255,0.25)', color: '#fff', borderRadius: '12px', padding: '2px 10px', fontSize: '12px', marginLeft: 'auto' }}>{fhirSummary.allergies.length}</span>
                      </div>
                      <div style={{ padding: '14px 18px', display: 'flex', flexWrap: 'wrap', gap: '8px', background: '#fff9f8' }}>
                        {fhirSummary.allergies.map((a, i) => (
                          <span key={i} style={{ background: '#fdecea', color: '#922b21', border: '1px solid #f5c6c2', borderRadius: '20px', padding: '6px 14px', fontSize: '13px', fontWeight: '500' }}>
                            {extractShortText(a.code?.text || a.substance?.text) || 'Unknown'}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Medications Section */}
                  {fhirSummary.medications.length > 0 && (
                    <div style={{ border: '1px solid #c3e6cb', borderRadius: '10px', overflow: 'hidden' }}>
                      <div style={{ background: '#1a7a4a', padding: '12px 18px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ fontSize: '18px' }}>💊</span>
                        <span style={{ color: '#fff', fontWeight: '700', fontSize: '14px' }}>Medications</span>
                        <span style={{ background: 'rgba(255,255,255,0.25)', color: '#fff', borderRadius: '12px', padding: '2px 10px', fontSize: '12px', marginLeft: 'auto' }}>{fhirSummary.medications.length}</span>
                      </div>
                      <div style={{ padding: '14px 18px', display: 'flex', flexWrap: 'wrap', gap: '8px', background: '#f6fff9' }}>
                        {fhirSummary.medications.map((m, i) => (
                          <span key={i} style={{ background: '#e9f7ef', color: '#1a5c35', border: '1px solid #b7dfc7', borderRadius: '20px', padding: '6px 14px', fontSize: '13px', fontWeight: '500' }}>
                            {extractShortText(m.medicationCodeableConcept?.text || m.note?.[0]?.text) || 'Unknown'}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                </div>
              )}
            </div>

            {/* Footer */}
            <div style={{ padding: '14px 24px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowFhirSummary(false)} style={{ background: '#024C9C', color: '#fff', border: 'none', borderRadius: '6px', padding: '10px 28px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}>
                Close
              </button>
            </div>

          </div>
        </div>
      )}

    </div>
  );
}

export default PatientDashboard;
